import { create } from 'zustand';
import type { EffectId } from '../gpu/types';

export type CaptureMode = 'single' | 'strip3' | 'strip4' | 'video';

export type BoothPhase =
  | 'idle'
  | 'countdown'
  | 'capturing'
  | 'preview'
  | 'uploading'
  | 'done'
  | 'error';

export interface RecentShare {
  shareId: string;
  kind: 'photo' | 'video';
  shareUrl: string;
  mediaUrl: string;
  capturedAt: number;
}

export interface BoothState {
  mode: CaptureMode;
  effect: EffectId;
  phase: BoothPhase;
  countdownValue: number;
  recordingProgress: number; // 0..1
  errorMessage: string | null;
  recent: RecentShare[];
  faceTrackingAvailable: boolean | null; // null = unknown / loading

  setMode(mode: CaptureMode): void;
  setEffect(effect: EffectId): void;
  setPhase(phase: BoothPhase): void;
  setCountdown(value: number): void;
  setRecordingProgress(value: number): void;
  setError(message: string | null): void;
  setFaceTrackingAvailable(ok: boolean | null): void;
  pushShare(share: RecentShare): void;
}

export const useBoothStore = create<BoothState>((set) => ({
  mode: 'single',
  effect: 'normal',
  phase: 'idle',
  countdownValue: 0,
  recordingProgress: 0,
  errorMessage: null,
  recent: [],
  faceTrackingAvailable: null,

  setMode: (mode) => set({ mode }),
  setEffect: (effect) => set({ effect }),
  setPhase: (phase) => set({ phase }),
  setCountdown: (countdownValue) => set({ countdownValue }),
  setRecordingProgress: (recordingProgress) => set({ recordingProgress }),
  setError: (errorMessage) => set({ errorMessage }),
  setFaceTrackingAvailable: (ok) => set({ faceTrackingAvailable: ok }),
  pushShare: (share) =>
    set((s) => ({ recent: [share, ...s.recent].slice(0, 8) })),
}));
